import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './law-enforcement/HeroSection';
import { IntroSection } from './law-enforcement/IntroSection';
import { PremierProgramsSection } from './law-enforcement/PremierProgramsSection';
import { UseOfForceSection } from './law-enforcement/UseOfForceSection';
import { EducatingSection } from './law-enforcement/EducatingSection';
export function LawEnforcementPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-840">
      <Navbar data-id="element-841" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-842">
        <HeroSection data-id="element-843" />
        <IntroSection data-id="element-844" />
        <PremierProgramsSection data-id="element-845" />
        <UseOfForceSection data-id="element-846" />
        <EducatingSection data-id="element-847" />
      </main>
      <Footer data-id="element-848" />
    </div>;
}